// extracted by mini-css-extract-plugin
export default {"loader":"small-loader_loader__YObyH","loader--orange":"small-loader_loader--orange__J7JD6","loader--light":"small-loader_loader--light__a-wos","l13":"small-loader_l13__5ToTB"};